import theme from "../../theme";
import type { PrivacyPolicyStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<PrivacyPolicyStyles, SxProps<Theme>> => {
  return {
    root: {
      [theme.breakpoints.up("sm")]: {
        height: "80%",
        width: "80%",
        top: "5%",
        left: "10%",
      },
      [theme.breakpoints.down("sm")]: { overflow: "scroll" },
    },

    wrapper: { width: "100%", height: "100%" },

    close: { position: "fixed", top: 0, left: 0 },
  };
};

export default getStyles;
